export default __webpack_public_path__ + "static/media/title_pc.84e8bc36.png";